/* eslint-disable jsx-a11y/anchor-is-valid */
import { AMP_SELECT_VEHICLE_LOCATIONS } from "analytics/amplitude/amplitudeEvents";
import Popover from "component/design-system/popover/Popover";
import PAText from "component/design-system/typography/PAText/PAText";
import HeaderAutoComplete from "component/header/header-autocomplete.component";
import Spinner from "component/spinner/spinner.component";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { isBusinessHP } from "util/helper/helper";
import GarageDropdownWrapper from "../GarageDropdownWrapper";
import HelpCenter from "../HelpCenter";
import SwitchLanguage from "../SwitchLanguage";
import commonStyles from "../style.module.scss";
import styles from "./sticky-header-desktop.module.scss";

const CartSummary = dynamic(() => import(/* webpackChunkName: "cart-summary" */"../cart-summary/CartSummary"));
const MultipleCartSummary = dynamic(() => import(/* webpackChunkName: "MultipleCartSummary" */"../multiple-cart-summary/MultipleCartSummary"));
const HomePopover = dynamic(() => import(/* webpackChunkName: "home-popover" */"component/design-system/popover/HomePopover"));
const PopUpSignedInAccount = dynamic(() => import(/* webpackChunkName: "popup-signedin" */ "../PopUpSignedInAccount"));
const PopUpSignInAccount = dynamic(() => import(/* webpackChunkName: "popup-signin" */ "../PopUpSignInAccount"));

function StickyHeaderDesktop(props: any) {
  const {
    liveChat, onClickLogin, onClickSignup, handleShoppingCartClick,
    callBack,
  } = props;

  // const { t, i18n } = useTranslation();
  const { t } = useTranslation("common");
  const auth = useSelector((state: RootState) => state.authenticationState);
  const { businessCustomer } = auth;

  const shoppingCart = useSelector((state: RootState) => state.shoppingCart);
  const { numberOfItems } = shoppingCart;

  const isLoading = auth.refreshStatus !== "complete";
  const { asPath } = useRouter();
  const isBusinessPage = isBusinessHP(asPath);

  // We can't use isItHomePage /#regular-service Because it will scroll to regular service &
  // after it will scroll to HomePopover
  const PopoverToShow = asPath === "/" ? HomePopover : Popover;

  return (
    <>

      <div className={`text-center ${styles.header_autocomplete}`}>
        <HeaderAutoComplete
          vehicleDropdown={<GarageDropdownWrapper loc={AMP_SELECT_VEHICLE_LOCATIONS.HEADER} callBack={callBack} />}
        />
      </div>

      <div className={styles.container}>
        <div className={`hidden-xs text-center justify-content-between ${styles.dropdown_options}`}>

          {/* hide for now */}
          {/* <div className="each-label p-t-5 d-flex align-items-center">
<img src="/canadian.png" alt="canadian" style={{ height: 18.2, width: 40, marginBottom: 2 }} />
<div className="icon-label">
<span style={{ textDecoration: "underline" }} className="p-5">EN</span>
|
<span className="p-5">FR</span>
</div>
</div> */}

          {/* hide for now */}
          {/* <div className="each-label p-t-5 d-flex align-items-center">
<img src="/canadian.png" alt="canadian" style={{ height: 18.2, width: 40, marginBottom: 2 }} />
<div className="icon-label">
<span style={{ textDecoration: "underline" }} className="p-5">EN</span>
|
<span className="p-5">FR</span>
</div>
</div> */}

          <div className={`p-l-10  p-r-10 ${styles.each_label}`} style={{ minHeight: 61 }}>
            <HideIf show={!(isBusinessPage || auth.businessCustomer)}>
              <i className={`fa fa-comments ${styles.icon}`} />
              <Popover
                component={<HelpCenter liveChat={liveChat} />}
              >
                <div className={`${commonStyles.dropdown_icon} ${styles.icon_label}`}>{t("24/7 Help")}</div>
              </Popover>
            </HideIf>
          </div>

          <div className={`d-flex ${styles.header_dropdowns}`}>
            <div className={`${styles.each_label} d-flex align-items-center`}>
              <SwitchLanguage />
            </div>

            <div className={styles.each_label} style={{ minWidth: 82, minHeight: 61 }}>

              <HideIf show={!isLoading}>

                <i className={`fa fa-user-circle-o ${styles.icon}`} aria-hidden="true" />
                <PopoverToShow
                  component={!auth.loggedIn ? <PopUpSignInAccount onClickLogin={onClickLogin} onClickSignup={onClickSignup} />
                    : <PopUpSignedInAccount />}
                  delay={200}
                  callBack={callBack}
                >
                  <div>
                    <div className={`${commonStyles.dropdown_icon} ${styles.icon_label}`}>{t("My Account")}</div>
                    <span className={styles.sub_heading}>{`${t("Hello")}, ${!auth.loggedIn ? t("Sign in") : ` ${auth.firstName}`}`}</span>
                  </div>
                </PopoverToShow>
              </HideIf>
              {isLoading && (
                <Spinner />
              )}
            </div>

            <Link
              href="/shopping-cart"
              prefetch={false}
              style={{ display: "flex", flexDirection: "column", textDecoration: "none" }}
              className={`${commonStyles.header_link} ${styles.each_label}`}
              onClick={handleShoppingCartClick}
              title="Take a Look at Your Cart"
            >

              <i className={`fa fa-shopping-cart ${styles.icon}`} style={{ fontSize: 35 }} />
              <PAText className="visible-sm">Cart</PAText>
              <span className={`label label-danger ${commonStyles.cart_count}`} style={{ fontSize: "100%", marginLeft: "calc(1.5 * var(--safari-root-font, 10px))" }}>
                {!isLoading && numberOfItems}
              </span>
              <Popover
                component={businessCustomer ? <MultipleCartSummary /> : <CartSummary />}
                placement="bottom-end"
                lazyLoad
                popoverContentClassName={businessCustomer ? styles.popover_content_className : ""}
                className={styles.popover}
              >
                <div className={`${commonStyles.dropdown_icon} ${styles.icon_label}`}>{t("Cart")}</div>
              </Popover>

            </Link>
          </div>
        </div>
      </div>

    </>
  );
}

export default StickyHeaderDesktop;
